/**
 * Videos de los manuales de uso para residentes.
 *
 * Los videos (narrados por Habi) viven en el landing `habitia_sitio_presentacion`
 * y se publican en habitia.ai (`/manuales/video/<slug>.mp4`, versión vertical
 * `-ig.mp4` para WhatsApp/Instagram y poster `-poster.webp`). Cada manual tiene
 * además su página pública en `/manuales/<slug>` (video + texto + FAQ).
 *
 * Acá solo referenciamos esas URLs públicas — NO se suben binarios al repo de la
 * app: el contenido canónico vive en la landing y se mantiene sincronizado solo.
 * Se usan como material comercial (tipo `video_manuales`) para mostrar la
 * experiencia del residente en reuniones o compartir el link por WhatsApp.
 */

export const TIPO_VIDEO_MANUALES = "video_manuales";

const SITE = "https://habitia.ai";

// Los 7 manuales que tienen video narrado (mismo orden que el hub /manuales).
export const MANUALES_VIDEO = [
  { slug: "activar-tu-cuenta", titulo: "Activá tu cuenta", desc: "De la invitación por WhatsApp a entrar al edificio, en un minuto." },
  { slug: "reportar-un-problema", titulo: "Reportar un problema", desc: "Cargar un reclamo del edificio — hasta por voz o por WhatsApp." },
  { slug: "seguimiento-de-incidencias", titulo: "Seguimiento de incidencias", desc: "Del reporte a la resolución, con aviso de resuelto por WhatsApp." },
  { slug: "pagar-gastos-comunes-online", titulo: "Pagar gastos comunes", desc: "Ver lo que se debe y pagar online, sin ir a un local." },
  { slug: "estado-de-cuenta", titulo: "Estado de cuenta", desc: "Cuánto debo, qué pagué y la evolución del mes, siempre claro." },
  { slug: "preguntale-a-habi", titulo: "Preguntale a Habi", desc: "El asistente con IA que responde del edificio, por app y WhatsApp." },
  { slug: "reservar-amenities", titulo: "Reservar amenities", desc: "Reservar la barbacoa, el gym o la piscina en dos toques." },
];

/** Video horizontal (para mostrar en pantalla). */
export const manualVideoUrl = (slug) => `${SITE}/manuales/video/${slug}.mp4`;
/** Video vertical (para compartir por WhatsApp / Instagram). */
export const manualVideoIgUrl = (slug) => `${SITE}/manuales/video/${slug}-ig.mp4`;
/** Poster (primer frame) del video. */
export const manualPosterUrl = (slug) => `${SITE}/manuales/video/${slug}-poster.webp`;
/** Página pública del manual (video + texto + FAQ). */
export const manualPageUrl = (slug) => `${SITE}/manuales/${slug}`;
